import { OrganizationApi, ToastStateHandler } from '../../../api';
import { ChangeTeamLeadDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostTeamLead = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const exec = (id: string, body: ChangeTeamLeadDto) => {
        const { exec, abort } = organizationApi.changeTeamLead({
            params: { id },
            body,
            onSuccess: _ => {
                toastHandler.push('success', t('team.updateTeamLead'), t('team.updateTeamLead_Success'));
            },
            onError: err => {
                toastHandler.push('error', t('team.updateTeamLead'), err);
            },
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPostTeamLead;
